// #region imports
import { put, select } from 'redux-saga/effects';
import { CellPosition, IRange, SelectionCell } from '../../../types';
import { arrowKeyOnCell, enterKeyOnCell } from './viewsActions';
import {
  SheetAndView,
  selectSheetAndView,
} from '../../../selectors/sheetSelector';
import _ from 'lodash';
import {
  convertPositionToArea,
  isCellInsideArea,
  isEqualAreas,
} from '../../../utils/area/area';
import { updateSheetView } from '../../sheetsManagerSlice';
import {
  createNewPositionFromArrowKey,
  getAreaAndViewportAccordingToPos,
  invertKey,
  jumpCellWithCtrlKey,
} from '../../../utils/views/arrowKeys';
import {
  getNextVisibleRowCol,
  jumpActiveCellWithinSelections,
} from '../../../utils/views/selection';
import { getI18n } from 'react-i18next';
// #endregion

// #region enter key
export function* enterKeyMi({ payload }: ReturnType<typeof enterKeyOnCell>) {
  const { sheetId, windowWidth, windowHeight } = payload;
  const { sheet, sheetView }: SheetAndView = yield select((state) =>
    selectSheetAndView(state, sheetId)
  );
  // TODO: If cell editor is opened close it and then move selection to next cell (like we'll do for normal jumps)
  // TODO: If a single cell is selected open cell editor
  // TODO: If multiple cell selected then jump to next cell without openeing cell editor

  // console.log('sheetView', sheetView);

  const area = _.last(sheetView.selections)?.area;
  if (
    sheetView.selections.length > 1 ||
    (area && !isEqualAreas(area, sheetView.activeCellArea))
  ) {
    // !isSingleCell(area)
    const updatedViews = jumpActiveCellWithinSelections(
      sheet,
      sheetView,
      windowWidth,
      windowHeight
    );

    // console.log('newActiveCellArea', newActiveCellArea);

    yield put(
      updateSheetView({
        sheetId,
        ...updatedViews,
        // activeCell: newActiveCell,
        // activeCellArea: newActiveCellArea,
        // selections: newSelections,
        // viewport,
      })
    );
  } else {
    // TODO: Open cell editor
    console.log('open cell editor');
  }
}
// #endregion

// #region arrowy keys
export function* arrowKeysMi({ payload }: ReturnType<typeof arrowKeyOnCell>) {
  const { sheetId, ctrlKey, shiftKey, windowWidth, windowHeight } = payload;

  const isRtl = getI18n().dir() === 'rtl';
  let key = invertKey(payload.key, isRtl);

  const { sheet, sheetView }: SheetAndView = yield select((state) =>
    selectSheetAndView(state, sheetId)
  );

  // Selection Validation
  const position = { ...sheetView.activeCell };
  let selection = _.cloneDeep(_.last(sheetView.selections));

  if (!selection) return;
  if (!isCellInsideArea(position, selection.area)) {
    selection.area = convertPositionToArea(position);
    selection.cell = SelectionCell.Cell;
  }

  let newPartialPosition: Partial<CellPosition> = {};
  let correspondingPosition: Partial<CellPosition> = {};
  let range: IRange | undefined;

  // Get New Position
  if (ctrlKey) {
    newPartialPosition = jumpCellWithCtrlKey(sheet, sheetView, position, key);
  } else {
    const results = createNewPositionFromArrowKey(
      sheet,
      sheetView,
      // sheetView.activeCellArea,
      key,
      selection.area,
      shiftKey
    );
    range = results.range;
    newPartialPosition = results.position;
    correspondingPosition = results.correspondingPosition;
  }

  let updatedPosition = _.merge({ ...position }, newPartialPosition);
  // Sometimes in case of merge if top cell is hidden and user changes col we may need to check hidden row index
  updatedPosition = getNextVisibleRowCol(
    sheet,
    updatedPosition.ci,
    updatedPosition.ri,
    sheetView.filterResults,
    0
  );

  // Update Selection And Viewport
  const updatedView = getAreaAndViewportAccordingToPos(
    sheet,
    sheetView,
    newPartialPosition,
    range,
    {
      ...updatedPosition,
      ...correspondingPosition,
    },
    // updatedPosition,
    selection.area,
    selection,
    windowWidth,
    windowHeight,
    shiftKey
  );

  yield put(
    updateSheetView({
      sheetId,
      ...updatedView,
      selections: [selection],
      activeCell: shiftKey ? undefined : updatedPosition,
      activeCellArea: shiftKey ? undefined : selection.area,
    })
  );
}
// #endregion
